// extracted by mini-css-extract-plugin
export default {"widget":"Widget_widget__rsLtw"};